import useAddNoteAfterWatchingStock from '@/pages/CompanyReport/hooks/useAddNoteAfterWatchingStock';

import { AddNoteSVG } from './styled';

import { useCompanyNoteModal } from '@/components/Note';
import { Button } from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';

interface Props {
  label: string;
  companyId: string;
  tickerSymbol: string;
}

export const NotesButton = ({ label, companyId, tickerSymbol }: Props) => {
  const isAddNotesAfterWatchingStockEnabled = useAddNoteAfterWatchingStock({
    companyId,
  });

  const { openNoteModal, modalState } = useCompanyNoteModal();
  const { trackEvent } = useTracking({
    type: 'track',
    subject: 'addNoteSidebar',
  });

  if (!isAddNotesAfterWatchingStockEnabled) return null;

  return (
    <Button
      data-cy-id="add-note-button"
      marginLeft
      styleType="louder"
      alignIcon="left"
      disabled={modalState === 'adding'}
      onClick={() => {
        openNoteModal({
          companyId: companyId,
          uniqueSymbol: tickerSymbol,
        });
        trackEvent({
          action: 'click',
        });
      }}
    >
      <AddNoteSVG /> {label}
    </Button>
  );
};
